import { string } from "prop-types";
import { AppSegmento } from "./AppSegmento";
import { AudienciaCampania } from "./AudienciaCampania";

export class Campanium{
    idNmCampania: number;
    idPersona: number;
    idNmTiponotificacion: number;
    totalNotificacionesGeneradas?: number;
    totalNotificacionesEnviadas?: number;
    estado: string;
    fechaPlanificacionEnvio: string;
    fechaGeneracionNotificaciones?: string;
    ultimoCambio: string;
    segmentos: AppSegmento[];

    constructor(
        idNmCampania: number,
        idPersona: number,
        idNmTiponotificacion: number,
        totalNotificacionesGeneradas: number | undefined,
        totalNotificacionesEnviadas: number | undefined,
        estado: string,
        fechaPlanificacionEnvio: string,
        fechaGeneracionNotificaciones: string | undefined,
        ultimoCambio: string,
        segmentos: AppSegmento[]
      ) {
        this.idNmCampania = idNmCampania;
        this.idPersona = idPersona;
        this.idNmTiponotificacion = idNmTiponotificacion;
        this.totalNotificacionesGeneradas = totalNotificacionesGeneradas;
        this.totalNotificacionesEnviadas = totalNotificacionesEnviadas;
        this.estado = estado;
        this.fechaPlanificacionEnvio = fechaPlanificacionEnvio;
        this.fechaGeneracionNotificaciones = fechaGeneracionNotificaciones ?? "";
        this.ultimoCambio = ultimoCambio ?? "";
        this.segmentos = segmentos;
      }

    getSelectedSegmentos(audiencias: Array<AudienciaCampania>, indices: number[]){
        this.segmentos = [];
        for(var i = 0; i < indices.length; i++){
            const j = indices[i];
            var seg = new AppSegmento(parseInt(audiencias[j].idAudiencia),0,this.idNmCampania ?? 0, audiencias[j].descripcion);
            this.segmentos.push(seg);
        }
    }
      

    getPlannedDate() {
        return new Date(this.fechaPlanificacionEnvio);
    }

    // // Check if the planned date is in the future
    isPlannedForFuture() {
        return this.getPlannedDate() > new Date();
    }


}

    


